import PropTypes from 'prop-types'
import {
  INTERESTED_PARTY_FORM_TYPE,
  INDIVIDUAL_FORM_TYPE,
  INTERESTED_PARTY_LABEL,
  INDIVIDUAL_LABEL,
} from '../constants'
const PARENT_INDEX = 0

export const hasReachedMaxDepth = (depth, rules) => depth >= rules.maxDepth

// check if the current size of children
// if rules does not have an entry in the rules then default to the parent rules
export const hasReachedMaxChildren = (childrenLength, depth, rules) => {
  const maxSize = !rules.flow[depth]
    ? rules.flow[PARENT_INDEX].maxChildren
    : rules.flow[depth].maxChildren
  return childrenLength >= maxSize
}

export const canAddChild = (childrenLength, depth, rules) =>
  !hasReachedMaxDepth(depth, rules) &&
  !hasReachedMaxChildren(childrenLength, depth, rules)

export const getFormChildren = (depth, rules) => {
  return !rules.flow[depth]
    ? rules.flow[PARENT_INDEX].formChildren
    : rules.flow[depth].formChildren || []
}

export const getChildInitialSubType = (depth, rules) => {
  const formChildren = getFormChildren(depth, rules)
  if (formChildren.length < 1) {
    return INTERESTED_PARTY_FORM_TYPE
  } else {
    return formChildren[0].formType
  }
}

export const rulesType = {
  rules: PropTypes.shape({
    maxDepth: PropTypes.number,
    flow: PropTypes.arrayOf(
      PropTypes.shape({
        maxChildren: PropTypes.number,
        addMore: PropTypes.shape({
          checkboxMaxText: PropTypes.string,
          text: PropTypes.string,
          type: PropTypes.oneOf(['button', 'link']),
        }),
        formChildren: PropTypes.arrayOf(
          PropTypes.shape({
            formType: PropTypes.oneOf([
              INDIVIDUAL_FORM_TYPE,
              INTERESTED_PARTY_FORM_TYPE,
            ]),
            label: PropTypes.string,
          })
        ),
      })
    ),
  }),
}

export const rules = {
  maxDepth: 2,
  flow: [
    {
      addMore: {
        text: 'Add Interested Party (Max. 3)',
        childTypes: ['Interested Party', 'Individual'],
        type: 'button',
        checkboxMaxText:
          'Check if you have more than 3 Entities or Interested Parties. One of our representatives will contact you.',
      },
      formChildren: [
        {
          formType: INTERESTED_PARTY_FORM_TYPE,
          label: INTERESTED_PARTY_LABEL,
        },
        {
          formType: INDIVIDUAL_FORM_TYPE,
          label: INDIVIDUAL_LABEL,
        },
      ],
      maxChildren: 3,
    },
    {
      addMore: {
        text: 'Add Individual (Max. 3)',
        childTypes: ['Individual'],
        type: 'link',
        checkboxMaxText:
          'Check if you have more than 3 Individuals. One of our representatives will contact you.',
      },
      formChildren: [
        {
          formType: INDIVIDUAL_FORM_TYPE,
          label: INDIVIDUAL_LABEL,
        },
      ],
      maxChildren: 3,
    },
  ],
}

export const getTotalOwnershipOfGroup = (interestedParties = []) =>
  interestedParties
    .reduce((acc, cur) => {
      const ownership =
        cur.subFormType === INTERESTED_PARTY_FORM_TYPE
          ? Number(cur.interestedPartyOwnership)
          : Number(cur.individualOwnership)
      return Number(Number(acc) + Number(ownership || 0))
    }, 0)
    .toFixed(2)
